import { Component, OnInit } from '@angular/core';
import { SetPermissions } from '@app/_store/app.actions';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  public previousLocation: string;

  constructor(
    private store: Store
  ) { }

  ngOnInit(): void {
    this.store.dispatch(new SetPermissions(null));

    if (window?.history?.state?.location) {
      this.previousLocation = window.history.state.location;
    }
  }


}
